import React from 'react';

interface Props {
  cause: string;
  idList?: string[];
  imgUrl?: string;
}

export const MainCauseTitleSection: React.FC<Props> = ({ cause, idList, imgUrl }) => {
  return (
    <div className="pb-[1.5rem]">
      <h6 className="text-red mb-[1rem]   ">Main cause</h6>
      <div className="flex gap-[0.5rem]">
        <img src={imgUrl ? imgUrl : '../assets/icons/gray-bg/contract-inspect.svg'}></img>
        <span className="content-center">{cause}</span>
        {idList && <span className="content-center">({idList.map((item) => item + ',')})</span>}
      </div>
    </div>
  );
};
